import React, { useEffect, useRef, useState } from "react";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { loadTestimonial, saveTestimonial } from "../utils/Network";
import SelectLanguage from "../components/SelectLanguage";
export default function TestimonialContent({ id }) {
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(false);
  const [title, setTitle] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [language_id, setLanguageId] = useState(false);

  useEffect(() => {
    if (id) {
      loadTestimonial(id).then((testimonial) => {
        setTitle(testimonial.title);
        setName(testimonial.name);
        setLanguageId(testimonial.language);
        setDescription(testimonial.description);
      });
    }
  }, []);

  const handleDescriptionChange = (data) => {
    setDescription(data);
  };

  const handleValue = (value, name) => {
    switch (name) {
      case "language":
        setLanguageId(value);
        break;

      default:
        break;
    }
  };

  const SaveChanges = () => {
    setError(null);

    if (!title) {
      setError("Please enter Title");
      return;
    }

    if (!description) {
      setError("Please enter Description");
      return;
    }

    if (!language_id) {
      setError("Please Select Language");
      return;
    }

    setLoading(true);
    saveTestimonial(id, title, name, description, language_id).then(() => {
      setLoading(false);
      if (!id) window.location.href = "testimonials";
    });
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content-header">
          <h3 className="box-title mb-10"></h3>
          <ol className="breadcrumb">
            <li>
              <a href="/cms">
                <i className="fa fa-dashboard"></i> Home
              </a>
            </li>
            <li className="active">Testimonial</li>
          </ol>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-8">
              <div className="box ">
                <div className="box-header">Testimonial Details</div>
                <div className="box-body padding-10 bg-ddd">
                  <div className="form-group">
                    <input
                      type="text"
                      value={name}
                      name="name"
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      className="form-control "
                      placeholder="Name"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      value={title}
                      name="title"
                      onChange={(e) => {
                        setTitle(e.target.value);
                      }}
                      className="form-control "
                      placeholder="Title"
                    />
                  </div>

                  <div className="form-group">
                    <CKEditor
                      editor={ClassicEditor}
                      data={description}
                      onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        handleDescriptionChange(data);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="box bg-ddd">
                <div className="box-header">Information</div>
                <div className="box-body padding-10">
                  <div className="form-group">
                    <SelectLanguage
                      width={250}
                      callback={handleValue}
                      value={language_id}
                      border={"1"}
                    />
                  </div>
                </div>
                <div className="box-footer">
                  <button
                    className="btn btn-primary pull-right"
                    onClick={SaveChanges}
                  >
                    Save Changes
                  </button>
                  <a
                    href={`testimonials`}
                    className="btn btn-default pull-left"
                  >
                    Cancel
                  </a>
                </div>
                {error && (
                  <div className="alert alert-danger mt-5">{error}</div>
                )}
                {loading && (
                  <div className="alert alert-info  mt-5">Please Wait...</div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
